export default "__VITE_ASSET__DUr9NjiM__"